export const COMMON_SERVICES = "common/services";
